(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-liitt-lazy-reviews]');
  if (!roots.length) return;

  function hydrate(root) {
    var template = root.querySelector('template[data-liitt-reviews-template]');
    if (!template || root.dataset.loaded) return;
    root.dataset.loaded = 'true';
    root.appendChild(template.content.cloneNode(true));
    template.remove();

    root.querySelectorAll('script').forEach(function (original) {
      if (original.type && !/^(text\/javascript|module)$/.test(original.type)) return;
      var script = document.createElement('script');
      Array.from(original.attributes).forEach(function (attribute) {
        script.setAttribute(attribute.name, attribute.value);
      });
      script.textContent = original.textContent;
      original.replaceWith(script);
    });

    var loader = document.querySelector('script[src*="/judgeme-"][src*="/assets/loader.js"]');
    if (loader && window.jdgm) {
      window.jdgm._loaderExecuted = false;
      var script = document.createElement('script');
      script.src = loader.src;
      script.async = true;
      document.head.appendChild(script);
    }
  }


  function hydrateHash(hash, scroll) {
    if (!hash || hash === '#') return;
    var id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (error) { return; }
    var matched = false;
    roots.forEach(function (root) {
      var template = root.querySelector('template[data-liitt-reviews-template]');
      if (template && Array.from(template.content.querySelectorAll('[id]')).some(function (node) { return node.id === id; })) {
        hydrate(root);
        matched = true;
      }
    });
    if (matched && scroll) {
      var target = document.getElementById(id);
      if (target) target.scrollIntoView();
    }
  }

  // Explicit review links must work before the offscreen widget is hydrated.
  hydrateHash(window.location.hash, true);
  window.addEventListener('hashchange', function () { hydrateHash(window.location.hash, true); });
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var url = new URL(link.href, window.location.href);
    if (url.origin === window.location.origin && url.pathname === window.location.pathname) hydrateHash(url.hash, false);
  }, true);

  if (!('IntersectionObserver' in window)) {
    roots.forEach(hydrate);
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      hydrate(entry.target);
    });
  }, { rootMargin: '800px 0px' });

  roots.forEach(function (root) { observer.observe(root); });
})();
